const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:3001/graphql')
  .replace('/graphql', '');

/**
 * Converts a relative image path stored in DB (e.g. "product_images/PROD/img.png")
 * to a full URL served by NestJS (e.g. "http://localhost:3001/api/files/product-images/PROD/img.png")
 */
export function getProductImageUrl(imagePath) {
  if (!imagePath) return null;
  if (/^https?:\/\//.test(imagePath) || imagePath.startsWith('data:')) return imagePath;
  const relative = imagePath.replace(/^product_images\//, '');
  return `${API_BASE}/api/files/product-images/${relative}`;
}

/**
 * Uploads a video File object to the backend and returns the stored relative path.
 * Throws on failure.
 */
export async function uploadProductVideo(file) {
  const formData = new FormData();
  formData.append('video', file);
  const res = await fetch(`${API_BASE}/api/files/upload-product-video`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Upload échoué (${res.status})`);
  }
  const { path } = await res.json();
  return path; // e.g. "product_videos/1234567890-987654321.mp4"
}
